import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=2f95c99f&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=2f95c99f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports